import axios from 'axios';
import Global from '../utils/Global';

// Determine the base URL based on the environment
// export let baseURL;
// export let baseURL2;

// if (process.env.NODE_ENV === 'development') {
//     baseURL = 'http://localhost:8000'; // Development baseURL
//     baseURL2 = 'http://localhost:8000'; // Development baseURL
// } else {
//     baseURL = 'https://mibportal.com'; // Production baseURL
//     baseURL2 = 'https://mibportal.com'; // Production baseURL
// }

const ApiClient = axios.create({
    baseURL: Global.baseURL,
});

// Add a request interceptor to include auth token if available
ApiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('agent-connect-api-token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors
ApiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            // Handle unauthorized access
            handleUnauthorized();
        }
        return Promise.reject(error);
    }
);

// Function to handle 401 Unauthorized responses
const handleUnauthorized = () => {
    // Clear localStorage and update context or state
    localStorage.removeItem('agent-connect-api-token');
    localStorage.removeItem('agent-connect-current-user');
    // Redirect to login page if using react-router
    if (window.location) {
        window.location.href = '/login';
    }
};

export default ApiClient;
